import type { Tone } from '@constants/tones';

export function Dot({ tone, pulse }: { tone: Tone; pulse?: boolean }) {
  return <span className={`dot dot-${tone} ${pulse ? 'pulse' : ''}`} aria-hidden="true" />;
}
